<template>
	<div class="px-1 py-4 groups">
		<div class="flex-space-between--center">
			<h4 class="reg">Groups</h4>
			<span v-if="canManageGroups" class="flex-end--center">
				<CreateGroupButton :items="menuItems" />
			</span>
		</div>
		<AppLoader v-if="loading" class="pt-6" />
		<perfect-scrollbar v-else-if="allParentGroups.length > 0">
			<GroupsList :groups="allParentGroups" :hasEditPermissions="canManageGroups" />
		</perfect-scrollbar>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';

import AppDialogManagerService from '../../../components/dialogs/AppDialogManager/app-dialog-manager-service';
import { FeatureTypes } from '@/components/Billing/billing-types';
import CreateGroupButton from '@/components/Settings/groups/CreateGroupButton';
import GroupsList from '@/components/Settings/groups/GroupsList';
import { hasAccountPermission } from '@/store/modules/account/getters';
import { getGroups, updateGroup } from '@/store/modules/accountGroups/actions';
import { groups } from '@/store/modules/accountGroups/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'ManageGroups',
	components: {
		CreateGroupButton,
		GroupsList,
	},
	props: {},
	computed: {
		...mapGettersShorthand({ groups, hasAccountPermission }),
		allParentGroups() {
			const allGroups = this.groups;
			if (!allGroups) {
				return [];
			}
			return allGroups.filter((x) => x.parent == null);
		},
		canManageGroups() {
			return this.hasAccountPermission(AccountPermissions.ManageGroups);
		},
		menuItems() {
			return [
				{
					title: 'Manually',
					subTitle: 'Add and remove users manually',
					billingFeatureId: FeatureTypes.Groups,
					onClick: this.openManualGroupDialog,
				},
				{
					title: 'Sync',
					subTitle: 'Users from an app',
					billingFeatureId: FeatureTypes.SyncedGroups,
					onClick: this.openSyncedGroupDialog,
				},
			];
		},
	},
	methods: {
		...mapActions([getGroups.fullPath, updateGroup.fullPath]),
		async openManualGroupDialog() {
			await AppDialogManagerService.openManualGroupDialog();
		},
		async openSyncedGroupDialog() {
			await AppDialogManagerService.openSyncedGroupDialog();
		},
	},
	async mounted() {
		this.loading = true;
		try {
			await this[getGroups.fullPath]();
		} catch (err) {
			this.$toast.error('Failed getting all groups');
		} finally {
			this.loading = false;
		}
	},
	data: () => ({
		loading: true,
	}),
};
</script>

<style scoped>
h4.reg {
	font-size: 16px;
}
.groups {
	height: 46vh;
	max-height: 554px;
}
</style>
